export default __webpack_public_path__ + "static/media/hourse.25c085a3.svg";